// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9d3d9599","239":"abf521c0","455":"e23f4a8f"}[chunkId] + ".chunk.js";
};